import { c as g } from "react/compiler-runtime";
import { useState as u } from "react";
class y {
  synth = window.speechSynthesis;
  voices = [];
  lang = "en-US";
  constructor() {
    if (!this.synth) {
      console.warn("Your browser does not support speech synthesis");
      return;
    }
    this.loadVoices(), this.synth?.onvoiceschanged !== void 0 && (this.synth.onvoiceschanged = () => this.loadVoices());
  }
  loadVoices() {
    if (!this.synth) {
      console.warn("Your browser does not support speech synthesis");
      return;
    }
    this.voices = this.synth.getVoices().filter((e) => e.lang === this.lang);
  }
  speak(e) {
    if (!this.synth) {
      console.warn("Your browser does not support speech synthesis");
      return;
    }
    this.synth.speaking && (console.error("speechSynthesis.speaking"), this.synth.cancel());
    const t = new SpeechSynthesisUtterance(e), o = this.voices.filter((n) => n.lang === this.lang && n.localService);
    t.voice = o.find((n) => n.name.includes("Mark")) ?? o[0], console.log(t.voice), this.synth.speak(t);
  }
  stop() {
    this.synth.cancel();
  }
  setVoice(e) {
    this.voices = this.synth.getVoices().filter((t) => t.lang === e);
  }
  listofLang() {
    const e = this.synth.getVoices().map((t) => t.lang);
    return Array.from(new Set(e));
  }
}
const r = new y(), v = () => {
  const s = g(8), [e, t] = u(!1);
  let o;
  s[0] !== e ? (o = () => {
    t(!e);
  }, s[0] = e, s[1] = o) : o = s[1];
  const n = o;
  let i;
  s[2] !== e ? (i = (f) => {
    e && r.speak(f);
  }, s[2] = e, s[3] = i) : i = s[3];
  const h = i, a = d, l = S, p = k;
  let c;
  return s[4] !== e || s[5] !== h || s[6] !== n ? (c = {
    speak: h,
    setVoice: a,
    listofLang: l,
    stopSpeaking: p,
    enabled: e,
    toggleTranscription: n
  }, s[4] = e, s[5] = h, s[6] = n, s[7] = c) : c = s[7], c;
};
function d(s) {
  r.setVoice(s);
}
function S() {
  return r.listofLang();
}
function k() {
  r.stop();
}
export {
  v as useTextToSpeak
};
